/**
 * menu-main.js - handles the main menu
 * v2.0.1 - created 2025 by Simon Gerlesberger (simon.gerlesberger@gmail.com)
 * License: MIT
 */
export default class MainMenu {
    constructor(menuSelector, dbg) {
        this.menu = document.querySelector(menuSelector);
        this.menuItems = this.menu.querySelectorAll('li');
        this.subMenuContainer = this.menu.querySelector('#submenu-container');
        this.openButton = document.querySelector('.btn-menu-main');
        this.mobileOpenButton = document.querySelector('#menuMobile .btn-menu-main');
        this.closeButton = this.menu.querySelector('.btn-close');
        this.overlay = document.querySelector(".bg-dark.overlay");
        this.openClass = 'menu__open';
        this.subOpen = false;

        this.initMenu();
        this.initButtons(this.openButton, this.mobileOpenButton, this.closeButton);
        this.signFirstLevelItems(this.menu);
    }

    /**
     * initMenu - initializes the main menu
     */
    initMenu() {
        this.menuItems.forEach(item => {
            if(!item) {
                console.warn("MainMenu - initMenu: item is null or undefined, skipping...");
                return;
            }

            const link = item.querySelector('a');
            const plus = item.querySelector('.plus-sub');
            const close = item.querySelector('.close-sub');

            if(!link) {
                console.warn("MainMenu - initMenu: link is null or undefined, skipping item: ", item);
                return;
            }

            if (link.parentNode.classList.contains("has--children")) {
                // link click opens link
                if(plus) {
                    plus.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.toggleMenuItem(item);
                    });
                }
                if(close) {
                    close.addEventListener('click', (event) => {
                        event.preventDefault();
                        // console.log("MainMenu - initMenu: close button clicked, closing item", item);
                        this.closeSpecificMenuItem(item);
                    });
                }
            }
        });

        /* click on overlay => close menu */
        this.overlay.addEventListener('click', () => {
            this.closeMenu();
        });
    }

    /**
     * toggleMenuItem - toggles display of the given listitem
     * @param {*} item - the listitem to toggle
     */
    toggleMenuItem(item) {
        const isOpen = item.classList.contains(this.openClass);
        const first = item.classList.contains("first-level") ? true : false;

        first ? this.closeAllMenuItems() : undefined;

        if (!isOpen) {
            let parent = item.parentNode.parentNode;

            if (!parent) {
                console.warn("toggleMenuItem: parentNode is null, cannot add openClass to parent items");
                return;
            }

            // bubble up to add openClass to all parent LI elements
            while (parent && parent.tagName === 'LI') {
                parent.classList.add(this.openClass);
                parent = parent.parentNode.parentNode;
            }

            // open via class
            item.classList.add(this.openClass);

            // fire boundries move
            this.moveToBoundries(item);
        } else {
            this.closeSpecificMenuItem(item);
        }
    }

    /**
     * initialize all needed buttons with events
     * @param {*} openButton - the button to open the main menu
     * @param {*} mobileButton - the button to open the main menu on mobile, and close it if open
     * @param {*} closeButton - the button to close the main menu
     */
    initButtons(openButton, mobileButton, closeButton) {
        let arrowLeftBlack = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>';
        let arrowLeftGreen = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>';

        /* open MainMenu */
        openButton.addEventListener('click', () => {
            this.openMenu();
            this.closeAllMenuItems();
        });

        /* open/close MainMenu on mobile */
        mobileButton.addEventListener('click', () => {
            if (this.menu.classList.contains(this.openClass)) {
                this.mobileOpenButton.classList.remove(this.openClass);
                this.closeMenu();
            } else {
                this.mobileOpenButton.classList.add(this.openClass);
                this.openMenu();
            }
        });

        closeButton.addEventListener('click', () => {
            this.closeMenu();
        });

        let elems = document.querySelectorAll(".menu-main-helper .plus-sub ~ ul.list-group");

        elems.forEach(elem =>  {
            var btn = document.createElement("div");
            let _t = this;
            btn.classList.add("back-btn");
            btn.innerHTML = arrowLeftGreen + arrowLeftBlack + 'zurück';
            btn.addEventListener("click", function() {
                if(!this.parentNode.parentNode) {
                    console.warn("back-btn: parentNode or parentNode.parentNode is null, cannot close menu item");
                    return;
                } else {
                    let container = this.parentNode.parentNode;
                    container.classList.remove("menu__open");
                    _t.clearStyles(container);
                }
            });

            /* add to DOM */
            let first = elem.children[0];
            first.before(btn);
        });
    }

    /**
     * closes the given item / menu element
     * @param {*} item
     */
    closeSpecificMenuItem(item) {
        item.classList.remove(this.openClass);
        this.clearStyles(item);
    }

    /**
     * closes all menu items by removing their openClass
     */
    closeAllMenuItems() {
        let _t = this;
        this.menuItems.forEach(item => {
            item.classList.remove(_t.openClass);
            _t.clearStyles(item);
        });
    }

    /**
     * opens the menu
     */
    openMenu() {
        this.menu.classList.add(this.openClass);
    }

    /**
     * closes the menu
     */
    closeMenu() {
        this.menu.classList.remove(this.openClass);
        this.closeAllMenuItems();
    }

    clearStyles(element) {
        if(!element) {
            console.warn("clearStyles: element is null or undefined, cannot clear styles");
            return;
        }
        element.style = '';
    }

    /**
     * adds a class to first level items of menu
     */
    signFirstLevelItems(menu) {
        var elements = menu.querySelectorAll(".menu-main-helper > ul.list-group > li");
        elements.forEach(element => {
            element.classList.add("first-level");
        });
    }

    /**
     *
     * @param {*} element
     * @returns
     */
    moveToBoundries(element) {
        if(!element) {
            console.warn("moveToBoundries: element is null or undefined, cannot move to boundries");
            return;
        }
        // first get the top left of the active main-menu
        let subRect = this.subMenuContainer.getBoundingClientRect(),
            elementRect = element.getBoundingClientRect();

        // move the given element to the top left of the active main-menu
        element.style.position = 'absolute';
        element.style.width = "100%";
        element.style.height = subRect.height + 'px';

        if(subRect.top > 0 && element.classList.contains("first-level")) {
            element.style.top = subRect.top + 'px';
        }
        if(!element.classList.contains("first-level")) {
            element.style.top = '0px';
        }
        // console.log("moveToBoundries: moved element to top of subMenuContainer", subRect.top, subRect.left, element);
    }

}
